import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VerseOfTheDay from "@/components/VerseOfTheDay";
import HeroSection from "@/components/HeroSection";
import DownloadCTA from "@/components/DownloadCTA";
import AudioPlayer from "@/components/AudioPlayer";
import AdminPanel from "@/components/AdminPanel";
import Footer from "@/components/Footer";

const LandingPage = () => {
  return (
    <div className="landing-container max-w-lg mx-auto min-h-screen" data-testid="landing-page">
      {/* Hero - Welcome */}
      <HeroSection />

      {/* Verse of the Day */}
      <VerseOfTheDay />

      {/* Divider */}
      <div className="mx-5 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      {/* Download CTAs - Google Play + Web active, App Store "Próximamente" */}
      <DownloadCTA />

      {/* Divider */}
      <div className="mx-5 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      {/* Audio Player - Centro de Alabanzas */}
      <AudioPlayer />

      {/* Footer */}
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/r/:slug" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
